export const emptyValueCheck = (currentValue: any, originalValue: any) => {
  return originalValue === '' ? null : currentValue;
};
